import { render } from "./DialogSDColor.vue?vue&type=template&id=5f40c791"
import script from "./DialogSDColor.vue?vue&type=script&lang=js"
export * from "./DialogSDColor.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__